import { ClientStore } from 'src/app/stores/stores';
import { PICKUP_METHOD } from '../store-checkout/checkout.service';
import { CurrencyPipe } from '@angular/common';

export default class StoreUtils {
  static isAsapOrderEnabled(store: ClientStore, deliveryMode: string): boolean {
    // If no order receive option is selected, then do not show the component
    if (deliveryMode === undefined) {
      return false;
    }
    // If delivery at table is selected, then show the component only if selected in admin section
    if (
      deliveryMode === 'IN_STORE_LOCATION' &&
      store.settings.DELIVERY_IN_STORE_LOCATION_CHOOSE_ASAP_ORDER_DATE
    ) {
      return true;
    }
    // If pickup is selected, then show the component if selected in admin section
    if (
      deliveryMode === 'NO_LOCATION' &&
      store.settings.DELIVERY_NO_LOCATION_CHOOSE_ASAP_ORDER_DATE
    ) {
      return true;
    }
    // If delivery at address is selected, then show the component if selected in admin section
    if (
      deliveryMode === 'ADDRESS' &&
      store.settings.DELIVERY_ADDRESS_CHOOSE_ASAP_ORDER_DATE
    ) {
      return true;
    }

    return false;
  }

  static isFutureOrderEnabled(
    store: ClientStore,
    deliveryMode: string,
  ): boolean {
    // If no order receive option is selected, then do not show the component
    if (deliveryMode === undefined) {
      return false;
    }
    // If delivery at table is selected, then show the component only if selected in admin section
    if (
      deliveryMode === 'IN_STORE_LOCATION' &&
      store.settings.DELIVERY_IN_STORE_LOCATION_CHOOSE_FUTURE_ORDER_DATE
    ) {
      return true;
    }
    // If pickup is selected, then show the component if selected in admin section
    if (
      deliveryMode === 'NO_LOCATION' &&
      store.settings.DELIVERY_NO_LOCATION_CHOOSE_FUTURE_ORDER_DATE
    ) {
      return true;
    }
    // If delivery at address is selected, then show the component if selected in admin section
    if (
      deliveryMode === 'ADDRESS' &&
      store.settings.DELIVERY_ADDRESS_CHOOSE_FUTURE_ORDER_DATE
    ) {
      return true;
    }

    return false;
  }

  static getCurrencySymbol(store: ClientStore) {
    if (store.selectedCurrency) {
      return store.selectedCurrency.isoCode === 'XCD'
        ? 'XCD'
        : store.selectedCurrency.symbol;
    }

    if (store.currency.isoCode === 'XCD') {
      return 'XCD';
    }

    return store.currency.symbol;
  }

  static getCurrencySymbolFromCode(currencyCode: string): string {
    if (!currencyCode) return '';
    const currencyPipe = new CurrencyPipe('en-US');
    const formatted = currencyPipe.transform(
      0,
      currencyCode,
      'symbol',
      '1.0-0',
    );
    return formatted ? formatted.replace(/[\d\s.,]/g, '').trim() : currencyCode;
  }

  static getCurrencyIsoCode(store: ClientStore) {
    return store.selectedCurrency
      ? store.selectedCurrency.isoCode
      : store.currency.isoCode;
  }

  static getStoreLocale(store: ClientStore) {
    return store.selectedCurrency
      ? store.selectedCurrency.locale
      : store.locale;
  }

  static getParentStoreId(store: ClientStore) {
    return store?.relation?.parentStore?.storeId;
  }

  static isMapsDisabled() {
    return !(window as any).google?.maps;
  }

  static isItemLevelWishDateEnabled(store: ClientStore): boolean {
    return store?.settings?.WISH_DATE_PER_ORDER_ITEM === 'ENABLED';
  }
}
